import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLnoLockIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20 11H18V6C18 2.69 15.31 0 12 0C8.69 0 6 2.69 6 6C6 6.55 6.45 7 7 7C7.55 7 8 6.55 8 6C8 3.79 9.79 2 12 2C14.21 2 16 3.79 16 6V11H4C3.45 11 3 11.45 3 12V23C3 23.55 3.45 24 4 24H20C20.55 24 21 23.55 21 23V12C21 11.45 20.55 11 20 11ZM13.82 18.02C13.82 19.02 13 19.84 12 19.84C11 19.84 10.18 19.02 10.18 18.02V16.98C10.18 15.98 11 15.16 12 15.16C13 15.16 13.82 15.98 13.82 16.98V18.02Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLnoLockIcon.displayName = 'HierLnoLockIcon';
